import { render } from "./currency.component.vue?vue&type=template&id=40c85332&ts=true"
import script from "./currency.component.vue?vue&type=script&lang=ts"
export * from "./currency.component.vue?vue&type=script&lang=ts"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__